import {
  ACTION_ARGS,
  COMPONENT_STATE_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  getDefaultValueFromMetadata,
  pickArgs,
} from '../../../../utils/spds/metadata';
import { STRING } from '../../../../utils/component-validations';
import { on } from '@ember/modifier';
import CoreInput from '../../core/input.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';

const METADATA = {
  component: 'Spds::Action::SegmentedControl::Button',
  name: 'Segmented Control Button',
  description: 'Individual button within a segmented control group',
  meta: {
    ...pickArgs(ACTION_ARGS, ['onClick']).meta,
    ...pickArgs(COMPONENT_STATE_ARGS, ['disabled']).meta,
    ...pickArgs(CONTENT_ARGS, ['iconOnly']).meta,
    alignItems: {
      ...FLEX_ARGS.meta.alignItems,
      defaultValue: 'center',
    },
    groupName: {
      type: STRING,
      description: 'Name attribute for the radio group',
    },
  },
};

export default class SpdsActionSegmentedControlButton extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-action-segmented-control-button';
  classesToMapToArgs = ['iconOnly'];

  get alignItems() {
    return (
      this.args.alignItems ?? getDefaultValueFromMetadata(this.constructor.metadata, 'alignItems')
    );
  }

  get justifyContent() {
    return (
      this.args.justifyContent ??
      getDefaultValueFromMetadata(this.constructor.metadata, 'justifyContent')
    );
  }

  get labelId() {
    return this.composeSubcomponentId('label');
  }

  <template>
    <CoreInput
      @disabled={{@disabled}}
      @id={{this.id}}
      @name={{@groupName}}
      @type="radio"
      class={{this.classes}}
      data-test-spds-action-segmented-control-button
      {{on "click" @onClick}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      ...attributes
    />
    <FlexRow
      @alignItems={{this.alignItems}}
      @inline={{true}}
      @justifyContent={{this.justifyContent}}
      @tag="label"
      class="spds-action-segmented-control-button-label"
      data-test-spds-action-segmented-control-button-label
      for={{this.id}}
      id={{this.labelId}}
    >
      {{yield}}
    </FlexRow>
  </template>
}

export const ACTION_SEGMENTED_CONTROL_BUTTON_METADATA = SpdsActionSegmentedControlButton.metadata;
